import { ClientDatumSource } from '@upright/common/model/company-client-data/types';
import { RequestStatus } from '@upright/ui/api/common/types';
import { useInsightsLensContext } from '@upright/ui/common/upright/core/impact-lenses/insights/common/use-insights-lens-context';
import { toSimplifiedSource } from '@upright/ui/common/upright/core/impact-lenses/insights/source-description/source-description';
import Skeleton from 'react-loading-skeleton';

export function InsightsSourceDescriptionTooltipContent() {
  const ctx = useInsightsLensContext();
  if (!ctx) {
    return <></>;
  }
  const data = ctx.data;
  if (data.loadingStatus === RequestStatus.LOADING) {
    return <Skeleton width="5.0em" />;
  }
  const items = data.insights;
  if (!items) {
    return <>Error</>;
  }
  const sourceType = toSimplifiedSource(items);
  return <>{clientDatumSourceTooltipText(sourceType)}</>;
}

export function clientDatumSourceTooltipText(type: ClientDatumSource) {
  switch (type) {
    case ClientDatumSource.COMPANY_SUBMITTED:
      return <>Data provided by the company</>;
    case ClientDatumSource.UPRIGHT_COLLECTED:
      return (
        <>
          The data has been collected by Upright, using the company's public reporting. Sources may e.g. include the
          company's annual report, sustainability reports, websites, press releases and regulatory filings.
        </>
      );
  }
}
